export function checkMobile(userAgent: string, width: number, height: number): [boolean, boolean] {
  const phoneMatch = [/Android/i, /webOS/i, /BlackBerry/i, /Windows Phone/i];
  const iosMatch = [/iPhone/i, /iPad/i, /iPod/i];

  const phoneCheck = phoneMatch.some((toMatchItem) => {
    return userAgent.match(toMatchItem);
  });
  const iosCheck = iosMatch.some((toMatchItem) => {
    return userAgent.match(toMatchItem);
  });

  const screenAspect = width <= 600 && height <= 920;

  return [phoneCheck || iosCheck || screenAspect, iosCheck];
}
